<template>
  <div class="wt2-collapse-item" :class="{ 'is-active': isActive }">
    <div
      class="wt2-collapse-item-header"
      @click="handleHeaderClick"
      :class="{ 'is-active': isActive }"
    >
      <slot name="title">{{ title }}</slot>
      <div v-if="imagesOnlyNotice" class="wt2-text-s -sub-title">
        <span
          class="wticon wticon-Notice_mark"
          :title="imagesOnlyNotice"
        ></span>
      </div>
      <div class="wt2-collapse-item-arrow">
        <div class="chevron-container" :class="{ 'is-active': isActive }">
          <div class="line-1"></div>
          <div class="line-2"></div>
        </div>
      </div>
    </div>
    <div class="wt2-collapse-item-wrap">
      <div class="wt2-collapse-item-content" ref="collapseContent">
        <slot :updateHeight="updateHeight"></slot>
        <div class="wt2-collapse-item-spacer"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contentWrapStyle: {
        height: 'auto',
        display: 'block',
      },
      contentHeight: 0,
    };
  },

  inject: ['collapse'],

  props: {
    title: String,
    imagesOnlyNotice: String,
    name: {
      type: [String, Number],
      default() {
        return this._uid;
      },
    },
  },

  computed: {
    isActive() {
      return this.collapse.activeNames.indexOf(this.name) > -1;
    },
  },

  watch: {
    isActive() {
      this.expandCollapse();
    },
  },

  mounted() {
    this.expandCollapse();
  },

  methods: {
    expandCollapse() {
      if (this.isActive) {
        this.expandSection();
      } else {
        this.collapseSection();
      }
    },

    handleHeaderClick() {
      this.$parent.$emit('item-click', this);
    },

    collapseSection() {
      // temporarily disable all css transitions
      this.$refs.collapseContent.style.maxHeight = 0;
    },

    expandSection() {
      this.$nextTick(() => {
        const sectionHeight = this.$refs.collapseContent.scrollHeight;
        this.$refs.collapseContent.style.maxHeight = sectionHeight + 'px';
      });
    },

    updateHeight() {
      // update height of expanded section
      if (this.isActive) {
        this.expandSection();
      }
    },
  },
};
</script>
